"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListItemOverrides = void 0;
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
var createMuiListItemOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return ({
        root: {
            paddingTop: spacing(2),
            paddingBottom: spacing(2),
        },
        dense: {
            paddingTop: 0,
            paddingBottom: 0,
        },
        gutters: {
            paddingLeft: spacing(2),
            paddingRight: spacing(2),
        },
        secondaryAction: {
            paddingRight: spacing(12),
        },
        selected: {
            backgroundColor: colorManipulator_1.alpha(palette.text.primary, 0.04),
        },
    });
};
exports.createMuiListItemOverrides = createMuiListItemOverrides;
//# sourceMappingURL=MuiListItem.js.map